import { render, staticRenderFns } from "./side-nav.vue?vue&type=template&id=b74bae0c&scoped=true&"
import script from "./side-nav.vue?vue&type=script&lang=js&"
export * from "./side-nav.vue?vue&type=script&lang=js&"
import style0 from "./side-nav.vue?vue&type=style&index=0&id=b74bae0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74bae0c",
  null
  
)

export default component.exports